"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1414))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.130Z
 */
export const Calendar = createSVGIcon(
  <>
    <path
      d="M2.71429 4.42773C2.25963 4.42773 1.82359 4.60835 1.5021 4.92984C1.18061 5.25133 1 5.68736 1 6.14202V21.5706C1 22.0252 1.18061 22.4613 1.5021 22.7828C1.82359 23.1043 2.25963 23.2849 2.71429 23.2849H21.5714C22.0261 23.2849 22.4621 23.1043 22.7836 22.7828C23.1051 22.4613 23.2857 22.0252 23.2857 21.5706V6.14202C23.2857 5.68736 23.1051 5.25133 22.7836 4.92984C22.4621 4.60835 22.0261 4.42773 21.5714 4.42773H18.1429"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 11.2852H23.2857"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.14258 1V7.85714"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1426 1V7.85714"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.14258 4.42773H14.714"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Calendar",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
